import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Link from 'brandComponents/Link';

import {IAuthLoginFormForgotPasswordProps} from './IAuthLoginFormForgotPassword';
import messages from './messages';

import styles from './AuthLoginFormForgotPassword.module.scss';

const AuthLoginFormForgotPassword = (props: IAuthLoginFormForgotPasswordProps) => {
	const intl = useIntl();

	return (
		<div className={cn(styles['auth__login-form__forgot-password'], props['classNames'])}>
			<Link to="/reset-password">{intl.formatMessage(messages.forgotPassword)}</Link>
		</div>
	);
};

export default AuthLoginFormForgotPassword;
